import { FaImdb, FcWikipedia, GlobeIconFc, SiLinkedin } from '@icon/react-icons';
import { blue } from '@material-ui/core/colors';
import { FaceTwoTone } from '@material-ui/icons';
import * as userService from 'services/user';
import { SubSectionTitle } from '../common';
import FacebookIcon from '@material-ui/icons/Facebook';
import { CompanyBasicFormField, CompanyBasicFormFieldProps, createTextAttr } from '../basic-field';
import { HelperTextTip } from '@components/hepler-text-tip';
import { ColoredChipIconButton } from '@components/colored-elements';
import AddIcon from '@material-ui/icons/Add';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import { TrashFill } from '@icon/react-icons';
import { red } from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
// import GroupIcon from '@material-ui/icons/GroupIcon';
import HttpIcon from '@material-ui/icons/Http';
import SocialMediaIcon from '@icon/social-media';
import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import {
  Divider,
  Grid,
  Avatar,
  InputLabel,
  TextField,
  Select,
  FormControl,
  Typography,
  Box,
  Chip,
  Link,
  Tooltip,
} from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
// import { VerifiedDetails } from './section-utils';
import { rbac } from '@lib/common';

export const SourceUrls = ({ source_urls }) => {
 // console.log("SourceUrls component rendered with source_urls:", source_urls);
  const form = useFormContext();
  const watchOnOtherSocialUrl = form.watch('source_urls');
  const [company, setCompany] = useState(null);
  const initialNumberofUrls = source_urls.length;
  const [indexesAttributes, setIndexesAttributes] = useState(
    Array.from(Array(initialNumberofUrls || 1), (_, i) => i)
  );
  const [counterAttributes, setCounterAttributes] = useState(initialNumberofUrls || 1);
  const addAttributes = useCallback(() => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes, counterAttributes];
    });
    setCounterAttributes(prevCounter => prevCounter + 1);
  }, [indexesAttributes, counterAttributes]);

  const removeAttributes = useCallback(index => {
    setIndexesAttributes(prevIndexes => {
      return [...prevIndexes.filter(item => item !== index)];
    });
  }, []);
  //   const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState(
    (company &&
      company.verified_sections &&
      company.verified_sections.social_section &&
      company.verified_sections.social_section.verified)
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.social_section &&
    watchOnVerifiedSections.social_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.social_section &&
    watchOnVerifiedSections.social_section.verified_at + ' IST';

  return (
    <>
      <Grid container justify="space-between" style={{ marginRight: '30px' }}>
        <Grid item>
          <SubSectionTitle
            icon={
              <HttpIcon
                fontSize="large"
                style={{
                  color: '#9be026',
                  background:
                    'radial-gradient(square, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
                }}
              />
              // <ImdbIcon fontSize="large" />
            }
            title="Source URLs"
            subTitle="Additional Source URLs"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip title="Add Source URLs">
            <StyledFab
              onClick={addAttributes}
              // disabled={rbac('C2C_AddSourceURL', '', 'Button')}
              color="primary"
              aria-label="add"
              size="small">
              <AddIcon />
            </StyledFab>
          </Tooltip>
        </Grid>
      </Grid>
      <Divider />
      <br />
      <Grid
        container
        spacing={1}
        justify="space-between"
        // style={{ display: 'flex' }}
        // key={indexOfAttribute}
      >
        {indexesAttributes.map((indexOfAttribute, i) => {
          return socialAttrs.map((attr, i) => {
            return (
              <Grid item container style={{ display: 'flex' }} xs={6} key={indexOfAttribute}>
                <Grid item xs={10}>
                  <CompanyBasicFormField
                    {...attr}
                    fullWidth
                    name={`source_urls[${indexOfAttribute}]`}
                    defaultValue={
                      watchOnOtherSocialUrl ? watchOnOtherSocialUrl[indexOfAttribute] : ''
                    }
                  />
                </Grid>
                {indexesAttributes.length > 1 ? (
                  <Grid item xs={2}>
                    <div
                      style={{
                        marginTop: '10px',
                        justifyContent: 'center',
                        display: 'flex',
                        marginRight: '20px',
                      }}>
                      <Tooltip title="Delete Source URL">
                        <ColoredChipIconButton
                          onClick={() => removeAttributes(indexOfAttribute)}
                          pointer
                          colored={red[900]}
                          size="small"
                          icon={<TrashFill />}
                        />
                      </Tooltip>
                    </div>
                  </Grid>
                ) : null}
              </Grid>
            );
          });
        })}
      </Grid>
    </>
  );
};

const socialAttrs = [createTextAttr('source_urls', 'Source URL', 'Addtional Source URLs')];

const attrs: CompanyBasicFormFieldProps[] = [
  createTextAttr(
    'website',
    'Official Website',
    <HelperTextTip
      text="URL of the official company website"
      tip="[Tip: No third party site links]"
    />,
    <GlobeIconFc />
  ),
  createTextAttr(
    'social_linkedin_url',
    'LinkedIn',
    'URL of the LinkedIn company page',
    <SiLinkedin style={{ color: '#0e76a8' }} />
  ),
  // createTextAttr(
  //   'social_imdb_pro_url',
  //   'IMDb Pro',
  //   'URL of the IMDBPro company page',
  //   <FaImdb
  //     style={{
  //       color: '#f3ce13',
  //       background:
  //         'radial-gradient(circle, rgba(2,0,36,1) 55%, rgba(255,255,255,1) 55%, rgba(255,255,255,1) 100%)',
  //     }}
  //   />
  // ),
  createTextAttr(
    'social_facebook_url',
    'Facebook',
    'URL of the Facebook company page',
    <FacebookIcon style={{ color: '#39569c' }} />
  ),
  createTextAttr('social_wiki_url', 'Wiki', 'URL of the Wiki company page', <FcWikipedia />),
];
const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
